module.exports = __webpack_public_path__ + "b7793aa9.png";